import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const checkSpecialDocumentTypeIsFilledWithNoteRule: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	const documentType = control.get('documentType')!.value;
	const documentNotes = control.get('documentNotes')!.value;

	return documentType ===  "EGD007" && !documentNotes ? { checkSpecialDocumentTypeIsFilledWithNoteFlag: true } : null;
};
